import { apiBase, createClient, deviceId, tokenStore } from '@ck/sdk';

const saved = tokenStore('ck.trader.session');
const VIEW = 'ck.trader.staffview';
/** A staff "open as client" link carries #as=<token>. It lives only in this tab and never touches the client's own saved sign-in. */
(() => {
  const m = /[#&]as=([A-Za-z0-9_-]{20,})/.exec(location.hash);
  if (!m) return;
  try { sessionStorage.setItem(VIEW, m[1]!); } catch { /* ignore */ }
  history.replaceState(null, '', location.pathname + location.search);
})();
const viewToken = () => { try { return sessionStorage.getItem(VIEW); } catch { return null; } };
export const staffView = () => !!viewToken();
export const session = {
  get: () => viewToken() ?? saved.get(),
  set: (v: string | null) => { if (viewToken()) { if (!v) try { sessionStorage.removeItem(VIEW); } catch { /* ignore */ } return; } saved.set(v); },
};
export const API_URL = apiBase(import.meta.env.VITE_API_URL);
export const DEMO = import.meta.env.VITE_DEMO !== 'false';

let onSignedOut: () => void = () => undefined;
export const setSignedOutHandler = (fn: () => void) => { onSignedOut = fn; };

export const api = createClient({
  baseUrl: API_URL,
  tenant: import.meta.env.VITE_TENANT || undefined,
  token: () => session.get(),
  device: () => deviceId(),
  onUnauthorized: () => { session.set(null); onSignedOut(); },
});

export function remember(key: string, value?: string | null): string | null {
  try {
    if (value === null) localStorage.removeItem(key);
    else if (value !== undefined) localStorage.setItem(key, value);
    return localStorage.getItem(key);
  } catch {
    return value ?? null;
  }
}
